/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(() => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: Tokens.spacing['$sp-4']
    }
  },
  alert: {
    marginTop: Tokens.spacing['$sp-6']
  },
  userList: {
    paddingLeft: Tokens.spacing['$sp-6']
  },
  userListItem: {
    display: 'list-item',
    listStyleType: 'disc',
    padding: 0
  }
}));
